{
  "a": {
    "viewBox": "0 0 1440 1000",
    "path": "M1440 0q-100 35.052-196.907 47.423c-96.907 12.371-309.941-30.029-545.361 65.979-194.666 79.388-297.563 264.602-298.969 432.99-1.406 168.387 164.781 370.737 319.588 407.216 144.012 33.936 383.963-20.359 494.845-11.34Q1345.68 953.044 1440 1000V0z"
  },
  "b": {
    "viewBox": "0 0 1440 1000",
    "path": "M1440 78.133Q1302.61 1.083 1165 .012c-281.049-2.187-507.797 294.336-784 291.45Q153.249 289.083 0 151.246V659.03q382.132 353.269 950 340.526 347.396-7.795 490-80.123v-841.3z"
  },
  "c": {
    "viewBox": "0 0 1440 836",
    "path": "M1440 217.487q-266.838 18.754-400-40C776.472 61.211 511.125 2.743 270 .487q-155.812-1.459-270 67v750q201.952 30.119 400 10c288.251-29.283 558.393-100.818 740-190q181.607-89.183 300-180v-240z"
  }
}
